"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutingToken = void 0;
const decorators_1 = require("../core/decorators");
let RoutingToken = class RoutingToken {
    routingTree = new Map();
    pathTree = new Map();
    current = {
        hash: [],
        variables: [],
    };
};
exports.RoutingToken = RoutingToken;
exports.RoutingToken = RoutingToken = __decorate([
    decorators_1.injectable
], RoutingToken);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91dGluZy10b2tlbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wYWNrYWdlcy9yb3V0aW5nL3JvdXRpbmctdG9rZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsbURBQWdEO0FBR3pDLElBQU0sWUFBWSxHQUFsQixNQUFNLFlBQVk7SUFDdkIsV0FBVyxHQUE2QixJQUFJLEdBQUcsRUFBRSxDQUFDO0lBQ2xELFFBQVEsR0FBd0IsSUFBSSxHQUFHLEVBQUUsQ0FBQztJQUMxQyxPQUFPLEdBQTZCO1FBQ2xDLElBQUksRUFBRSxFQUFFO1FBQ1IsU0FBUyxFQUFFLEVBQUU7S0FDZCxDQUFDO0NBQ0gsQ0FBQTtBQVBZLG9DQUFZO3VCQUFaLFlBQVk7SUFEeEIsdUJBQVU7R0FDRSxZQUFZLENBT3hCIn0=